(function () {
  "use strict";

  var t = {
    845: function _(t, e, n) {
      var _a,
          r = this && this.__extends || (_a = function a(t, e) {
        return _a = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          }
        }, _a(t, e);
      }, function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");

        function n() {
          this.constructor = t;
        }

        _a(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
      }),
          i = this && this.__awaiter || function (t, e, n, a) {
        return new (n || (n = Promise))(function (r, i) {
          function o(t) {
            try {
              c(a.next(t));
            } catch (t) {
              i(t);
            }
          }

          function s(t) {
            try {
              c(a.throw(t));
            } catch (t) {
              i(t);
            }
          }

          function c(t) {
            var e;
            t.done ? r(t.value) : (e = t.value, e instanceof n ? e : new n(function (t) {
              t(e);
            })).then(o, s);
          }

          c((a = a.apply(t, e || [])).next());
        });
      },
          o = this && this.__generator || function (t, e) {
        var n,
            a,
            r,
            i,
            o = {
          label: 0,
          sent: function sent() {
            if (1 & r[0]) throw r[1];
            return r[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");

              for (; o;) {
                try {
                  if (n = 1, a && (r = 2 & i[0] ? a.return : i[0] ? a.throw || ((r = a.return) && r.call(a), 0) : a.next) && !(r = r.call(a, i[1])).done) return r;

                  switch (a = 0, r && (i = [2 & i[0], r.value]), i[0]) {
                    case 0:
                    case 1:
                      r = i;
                      break;

                    case 4:
                      return o.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      o.label++, a = i[1], i = [0];
                      continue;

                    case 7:
                      i = o.ops.pop(), o.trys.pop();
                      continue;

                    default:
                      if (!((r = (r = o.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        o = 0;
                        continue;
                      }

                      if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                        o.label = i[1];
                        break;
                      }

                      if (6 === i[0] && o.label < r[1]) {
                        o.label = r[1], r = i;
                        break;
                      }

                      if (r && o.label < r[2]) {
                        o.label = r[2], o.ops.push(i);
                        break;
                      }

                      r[2] && o.ops.pop(), o.trys.pop();
                      continue;
                  }

                  i = e.call(t, o);
                } catch (t) {
                  i = [6, t], a = 0;
                } finally {
                  n = r = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var s = n(685),
          c = n(238),
          d = n(574),
          u = n(911),
          f = n(64),
          h = n(674),
          l = "0xbd66528a",
          p = "0x590e1ae3",
          b = function (t) {
        function e() {
          return null !== t && t.apply(this, arguments) || this;
        }

        return r(e, t), e.prototype.createSwapScript = function (t) {
          this.validateSwapParams(t);
          var e = (0, u.remove0x)((0, d.addressToString)(t.recipientAddress)),
              n = (0, u.remove0x)((0, d.addressToString)(t.refundAddress)),
              a = (0, c.padHexStart)(t.expiration.toString(16), 32),
              r = ["6080604052600080546001600160a01b031990811673", e, "1790915560018054821673", n, "17905560028054821673", (0, u.remove0x)(this.getMethod("getContractAddress")()), "1790819055600380549092166001600160a01b03919091161790557f", t.secretHash, "6004553480156100b157600080fd5b50610555806100c16000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c8063590e1ae31461003b578063bd66528a14610045575b600080fd5b610043610062565b005b6100436004803603602081101561005b57600080fd5b5035610235565b6004361461006f57600080fd5b7f", a, "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"].join("").toLowerCase();
          if (3116 !== Buffer.byteLength(r)) throw new Error("Invalid swap script. Bytecode length incorrect.");
          return r;
        }, e.prototype.validateSwapParams = function (t) {
          (0, d.validateValue)(t.value), (0, u.validateAddress)(t.recipientAddress), (0, u.validateAddress)(t.refundAddress), (0, d.validateSecretHash)(t.secretHash), (0, u.validateExpiration)(t.expiration);
        }, e.prototype.initiateSwap = function (t, e) {
          return i(this, void 0, void 0, function () {
            var n, a, r;
            return o(this, function (i) {
              switch (i.label) {
                case 0:
                  return this.validateSwapParams(t), [4, this.getMethod("getAddresses")()];

                case 1:
                  return n = i.sent(), [4, this.client.chain.getBalance(n)];

                case 2:
                  if ((a = i.sent()).isLessThan(t.value)) throw new h.InsufficientBalanceError("".concat(n[0], " doesn't have enough balance (has: ").concat(a, ", want: ").concat(t.value, ")"));
                  return r = this.createSwapScript(t), [2, this.client.chain.sendTransaction({
                    to: null,
                    value: new f.BigNumber(0),
                    data: r,
                    fee: e
                  })];
              }
            });
          });
        }, e.prototype.fundSwap = function (t, e, n) {
          return i(this, void 0, void 0, function () {
            var a, r;
            return o(this, function (i) {
              switch (i.label) {
                case 0:
                  return this.validateSwapParams(t), [4, this.getMethod("getTransactionByHash")(e)];

                case 1:
                  if (!(a = i.sent())) throw new h.TxNotFoundError("Transaction not found: ".concat(e));
                  return [4, this.getMethod("getTransactionReceipt")(e)];

                case 2:
                  if (!(r = i.sent())) throw new h.PendingTxError("Transaction receipt is not available: ".concat(e));
                  if (!r.contractAddress || "0x1" !== r.status) throw new h.TxFailedError("ERC20 swap initiation transaction failed: ".concat(r.transactionHash));
                  if (!this.doesTransactionMatchInitiation(t, a)) throw new h.InvalidDestinationAddressError("Contract creation does not match initiation parameters: ".concat(e));
                  return [4, this.getMethod("assertContractExists")(r.contractAddress)];

                case 3:
                  return i.sent(), [4, this.doesBalanceMatchValue(r.contractAddress, new f.BigNumber(0))];

                case 4:
                  if (!i.sent()) throw new h.InvalidDestinationAddressError("Contract is not empty: ".concat(r.contractAddress));
                  return [2, this.client.chain.sendTransaction({
                    to: r.contractAddress,
                    value: t.value,
                    fee: n
                  })];
              }
            });
          });
        }, e.prototype.claimSwap = function (t, e, n, a) {
          return i(this, void 0, void 0, function () {
            var r;
            return o(this, function (i) {
              switch (i.label) {
                case 0:
                  return this.validateSwapParams(t), (0, d.validateSecret)(n), (0, d.validateSecretAndHash)(n, t.secretHash), [4, this.verifyInitiateSwapTransaction(t, e)];

                case 1:
                  return i.sent(), [4, this.getMethod("getTransactionReceipt")(e)];

                case 2:
                  if (!(r = i.sent())) throw new h.PendingTxError("Transaction receipt is not available: ".concat(e));
                  return [4, this.getMethod("assertContractExists")(r.contractAddress)];

                case 3:
                  return i.sent(), [2, this.client.chain.sendTransaction({
                    to: r.contractAddress,
                    value: new f.BigNumber(0),
                    data: l + n,
                    fee: a
                  })];
              }
            });
          });
        }, e.prototype.refundSwap = function (t, e, n) {
          return i(this, void 0, void 0, function () {
            var a;
            return o(this, function (r) {
              switch (r.label) {
                case 0:
                  return this.validateSwapParams(t), [4, this.verifyInitiateSwapTransaction(t, e)];

                case 1:
                  return r.sent(), [4, this.getMethod("getTransactionReceipt")(e)];

                case 2:
                  if (!(a = r.sent())) throw new h.PendingTxError("Transaction receipt is not available: ".concat(e));
                  return [4, this.getMethod("assertContractExists")(a.contractAddress)];

                case 3:
                  return r.sent(), [2, this.client.chain.sendTransaction({
                    to: a.contractAddress,
                    value: new f.BigNumber(0),
                    data: p,
                    fee: n
                  })];
              }
            });
          });
        }, e.prototype.doesTransactionMatchInitiation = function (t, e) {
          var n = this.createSwapScript(t);
          return null === e._raw.to && e._raw.input === (0, u.ensure0x)(n);
        }, e.prototype.doesTransactionMatchClaim = function (t, e, n) {
          return (0, d.caseInsensitiveEqual)(e._raw.to, n.contractAddress) && e._raw.input.startsWith(l);
        }, e.prototype.doesTransactionMatchFunding = function (t, e, n) {
          return (0, d.caseInsensitiveEqual)(t._raw.to, e) && t._raw.input === (0, u.ensure0x)(n);
        }, e.prototype.doesBalanceMatchValue = function (t, e) {
          return i(this, void 0, void 0, function () {
            return o(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.client.chain.getBalance([t])];

                case 1:
                  return [2, n.sent().isEqualTo(e)];
              }
            });
          });
        }, e.prototype.getSwapSecret = function (t) {
          return i(this, void 0, void 0, function () {
            var e;
            return o(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.getMethod("getTransactionByHash")(t)];

                case 1:
                  return e = n.sent(), [2, (0, u.remove0x)(e._raw.input).substring(8)];
              }
            });
          });
        }, e.prototype.verifyInitiateSwapTransaction = function (t, e) {
          return i(this, void 0, void 0, function () {
            var n, a, r, i;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  return this.validateSwapParams(t), [4, this.getMethod("getTransactionByHash")(e)];

                case 1:
                  if (!(n = o.sent())) throw new h.TxNotFoundError("Transaction not found: ".concat(e));
                  return [4, this.getMethod("getTransactionReceipt")(e)];

                case 2:
                  if (!(a = o.sent())) throw new h.PendingTxError("Transaction receipt is not available: ".concat(e));
                  return [4, this.getMethod("assertContractExists")(a.contractAddress)];

                case 3:
                  return o.sent(), r = this.doesTransactionMatchInitiation(t, n), [4, this.doesBalanceMatchValue(a.contractAddress, t.value)];

                case 4:
                  return i = o.sent(), [2, r && a.contractAddress && "0x1" === a.status && i];
              }
            });
          });
        }, e.prototype.findInitiateSwapTransaction = function (t, e) {
          return i(this, void 0, void 0, function () {
            var n,
                a = this;
            return o(this, function (r) {
              switch (r.label) {
                case 0:
                  return this.validateSwapParams(t), [4, this.getMethod("getBlockByNumber")(e, !0)];

                case 1:
                  if (!(n = r.sent())) throw new h.BlockNotFoundError("Block #".concat(e, " is not available"));
                  return [2, n.transactions.find(function (e) {
                    return a.doesTransactionMatchInitiation(t, e);
                  })];
              }
            });
          });
        }, e.prototype.findFundSwapTransaction = function (t, e, n) {
          return i(this, void 0, void 0, function () {
            var a,
                r,
                i,
                s,
                c,
                d = this;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  return this.validateSwapParams(t), [4, this.getMethod("getBlockByNumber")(n, !0)];

                case 1:
                  if (!(a = o.sent())) throw new h.BlockNotFoundError("Block #".concat(n, " is not available"));
                  return [4, this.getMethod("getTransactionReceipt")(e)];

                case 2:
                  if (!(r = o.sent())) throw new h.PendingTxError("Transaction receipt is not available: ".concat(e));
                  return [4, this.getMethod("getContractAddress")()];

                case 3:
                  return i = o.sent(), [4, this.getMethod("generateErc20Transfer")(r.contractAddress, t.value)];

                case 4:
                  if (s = o.sent(), !(c = a.transactions.find(function (t) {
                    return d.doesTransactionMatchFunding(t, i, s);
                  }))) throw new h.TxNotFoundError("Funding transaction is not available: ".concat(e));
                  return [2, c];
              }
            });
          });
        }, e.prototype.findClaimSwapTransaction = function (t, e, n) {
          return i(this, void 0, void 0, function () {
            var a,
                r,
                i,
                s,
                c,
                u = this;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  return this.validateSwapParams(t), [4, this.getMethod("getBlockByNumber")(n, !0)];

                case 1:
                  if (!(a = o.sent())) throw new h.BlockNotFoundError("Block #".concat(n, " is not available"));
                  return [4, this.getMethod("getTransactionReceipt")(e)];

                case 2:
                  if (!(r = o.sent())) throw new h.PendingTxError("Transaction receipt is not available: ".concat(e));
                  return (i = a.transactions.find(function (e) {
                    return u.doesTransactionMatchClaim(t, e, r);
                  })) ? [4, this.getMethod("getTransactionReceipt")(i.hash)] : [2];

                case 3:
                  if (!(s = o.sent())) throw new h.PendingTxError("Claim transaction receipt is not available: ".concat(i.hash));
                  return "0x1" !== s.status ? [3, 5] : [4, this.getSwapSecret(i.hash)];

                case 4:
                  return c = o.sent(), (0, d.validateSecretAndHash)(c, t.secretHash), i.secret = c, [2, i];

                case 5:
                  return [2];
              }
            });
          });
        }, e.prototype.findRefundSwapTransaction = function (t, e, n) {
          return i(this, void 0, void 0, function () {
            var a, r;
            return o(this, function (i) {
              switch (i.label) {
                case 0:
                  return this.validateSwapParams(t), [4, this.getMethod("getBlockByNumber")(n, !0)];

                case 1:
                  if (!(a = i.sent())) throw new h.BlockNotFoundError("Block #".concat(n, " is not available"));
                  return [4, this.getMethod("getTransactionReceipt")(e)];

                case 2:
                  if (!(r = i.sent())) throw new h.PendingTxError("Transaction receipt is not available: ".concat(e));
                  return [2, a.transactions.find(function (e) {
                    return (0, d.caseInsensitiveEqual)(e._raw.to, r.contractAddress) && e._raw.input === p && a.timestamp >= t.expiration;
                  })];
              }
            });
          });
        }, e.SOL_CLAIM_FUNCTION = l, e.SOL_REFUND_FUNCTION = p, e;
      }(s.Provider);

      e.default = b;
    },
    175: function _(t, e, n) {
      var a = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.EthereumErc20SwapProvider = void 0;
      var r = a(n(845));
      e.EthereumErc20SwapProvider = r.default;
    },
    238: function _(t) {
      t.exports = require("@yaswap/crypto");
    },
    674: function _(t) {
      t.exports = require("@yaswap/errors");
    },
    911: function _(t) {
      t.exports = require("@yaswap/ethereum-utils");
    },
    685: function _(t) {
      t.exports = require("@yaswap/provider");
    },
    64: function _(t) {
      t.exports = require("@yaswap/types");
    },
    574: function _(t) {
      t.exports = require("@yaswap/utils");
    }
  },
      e = {},
      n = function n(a) {
    var r = e[a];
    if (void 0 !== r) return r.exports;
    var i = e[a] = {
      exports: {}
    };
    return t[a].call(i.exports, i, i.exports, n), i.exports;
  }(175);

  module.exports = n;
})();